import React from "react";
import {
  Button,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import EntityForm from "../../../../helpers/EntityForm";
import { Link } from "react-router-dom";
import PrivilegeCheckboxes from "./PrivilegeCheckboxes";
import Checkbox from "@mui/material/Checkbox";

const UserForm = ({
  user,
  shortDescription,
  longDescription,
}) => {
  return (
    <EntityForm isCreate={user === null}>
      <Link
        to="../updatePassword"
        style={{ alignSelf: "end" }}
      >
        <Button variant="contained">
          Update Password
        </Button>
      </Link>
      <input name="userEntityId" readOnly hidden value={user?.userEntityId}/>
      <input name="oldShortDescription" readOnly hidden
             value={encodeURIComponent(shortDescription)}
      />
      <input name="oldLongDescription" readOnly hidden
             value={encodeURIComponent(longDescription)}
      />
      <PrivilegeCheckboxes
        administrator={user?.administrator}
      />
      <TextField
        label="Title"
        type="text"
        id="title"
        name="title"
        required={false}
        defaultValue={user?.title}
        variant="outlined"
      />
      <TextField
        label="First Name"
        type="text"
        id="firstName"
        name="firstName"
        required={false}
        defaultValue={user?.firstName}
        variant="outlined"
      />
      <TextField
        label="Last Name"
        type="text"
        id="lastName"
        name="lastName"
        required={false}
        defaultValue={user?.lastName}
        variant="outlined"
      />
      <Stack
        direction={{ md: "row" }}
        gap={4}
      >
        <TextField
          label="Phone"
          type="text"
          id="phone"
          name="phone"
          required={false}
          defaultValue={user?.phone}
          variant="outlined"
          fullWidth
        />
        <TextField
          label="Timezone"
          type="text"
          id="timezone"
          name="timezone"
          required={false}
          defaultValue={user?.timezone}
          variant="outlined"
        />
      </Stack>
      <TextField
        label="Short Description"
        type="text"
        id="shortDescription"
        name="shortDescription"
        margin="normal"
        multiline={true}
        defaultValue={shortDescription}
        minRows={3}
        variant="outlined"
      />
      <TextField
        label="Long Description"
        type="text"
        id="longDescription"
        name="longDescription"
        margin="normal"
        multiline={true}
        defaultValue={longDescription}
        minRows={6}
        variant="outlined"
      />
      <TextField
        label="Url"
        type="text"
        id="url"
        name="url"
        required={false}
        defaultValue={user?.url}
        variant="outlined"
      />
      <TextField
        label="LinkedIn"
        type="text"
        id="linkedinUserId"
        name="linkedinUserId"
        required={false}
        defaultValue={user?.linkedinUserId}
        variant="outlined"
      />
      <TextField
        label="Facebook"
        type="text"
        id="facebookUserId"
        name="facebookUserId"
        required={false}
        defaultValue={user?.facebookUserId}
        variant="outlined"
      />
      <TextField
        label="Gmail"
        type="text"
        id="gmailUserId"
        name="gmailUserId"
        required={false}
        defaultValue={user?.gmailUserId}
        variant="outlined"
      />
      <TextField
        label="Skype"
        type="text"
        id="skypeUserId"
        name="skypeUserId"
        required={false}
        defaultValue={user?.skypeUserId}
        variant="outlined"
      />
      <TextField
        label="Address 1"
        type="text"
        id="address1"
        name="address1"
        required={false}
        defaultValue={user?.address1}
        variant="outlined"
      />
      <TextField
        label="Address 2"
        type="text"
        id="address2"
        name="address2"
        required={false}
        defaultValue={user?.address2}
        variant="outlined"
      />
      <TextField
        label="City"
        type="text"
        id="city"
        name="city"
        required={false}
        defaultValue={user?.city}
        variant="outlined"
      />
      <Stack
        direction={{ md: "row" }}
        gap={4}
      >
        <TextField
          label="State"
          type="text"
          id="state"
          name="state"
          required={false}
          defaultValue={user?.state}
          variant="outlined"
          fullWidth
        />
        <TextField
          label="Postal Code"
          type="text"
          id="postal"
          name="postal"
          required={false}
          defaultValue={user?.postal}
          variant="outlined"
        />
      </Stack>
      <TextField
        label="Show Order"
        type="number"
        id="showOrder"
        name="showOrder"
        required={false}
        defaultValue={user?.showOrder}
        variant="outlined"
      />
      <TextField
        label="Reminders"
        type="number"
        id="reminders"
        name="reminders"
        required={false}
        defaultValue={user?.reminders}
        variant="outlined"
      />
      <FormControlLabel
        control={
          <Checkbox
            id="useHtml"
            name="useHtml"
            defaultChecked={user?.useHtml}
          />
        }
        label={
          <Typography variant="body1">
            Use HTML
          </Typography>
        }
      />
    </EntityForm>
  );
};

export default UserForm;